import { render, staticRenderFns } from "./MyRecordsOffline.vue?vue&type=template&id=37d08d11&"
import script from "./MyRecordsOffline.vue?vue&type=script&lang=js&"
export * from "./MyRecordsOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports